





























import { computed, defineComponent, ref } from "@vue/composition-api";
import config from "@/config";
import BaseSendMessage from "@/components/BaseSendMessage";
import SendMessageController from "@/components/SendMessageController";
import TipController from "@/components/TipController";

export default defineComponent({
  name: "StreamChatSendMessage",
  components: { BaseSendMessage, SendMessageController, TipController },
  props: {
    threadId: { type: String, required: true },
  },
  setup() {
    const value = ref<string>("");
    const canTip = computed<boolean>(() => config.featureTippingLive && !(value.value.length > 0));

    return { canTip, value };
  },
});
